// extracted by mini-css-extract-plugin
export default {"author":"Item_author__sWY8S","content":"Item_content__sQqni","date":"Item_date__bBm0v","text":"Item_text__2A2Lo","user":"Item_user__ZeQgB"};